var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22.286,
    viewBox: "0 0 24 22.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M25.339,11.089h-7.88L15.064,3.943a.868.868,0,0,0-1.629,0l-2.395,7.146H3.107a.86.86,0,0,0-.857.857.63.63,0,0,0,.016.145.824.824,0,0,0,.359.605L9.1,17.261,6.616,24.488a.86.86,0,0,0,.295.964.829.829,0,0,0,.482.209,1.05,1.05,0,0,0,.536-.193l6.321-4.505,6.321,4.505a1,1,0,0,0,.536.193.77.77,0,0,0,.477-.209.849.849,0,0,0,.295-.964l-2.486-7.227,6.423-4.607.155-.134a.9.9,0,0,0,.279-.573A.907.907,0,0,0,25.339,11.089Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.6b3df239d6ab20125f013041ebae6d3c.svg";
export { ForwardRef as ReactComponent };